import { Injectable } from '@angular/core';

@Injectable()
export class DisplayService {

	leftCollapse = true;
	loading = 0;
	windowWidth = 0;
	windowHeight = 0;
	loaderIds = [];

	constructor() { }

	collapseLeft() {
		this.leftCollapse = !this.leftCollapse;
		this.resizeWindow();
	}

	/**
	 * Increase the count of things loading. If the count is greater than zero,
	 * the full-screen loading indicator will display.
	 * Call "endLoading()" when finished.
	 */
	startLoading() {
		this.updateLoadingCount(1);
	}

	/**
	 * Decrease the count of things loading.
	 * If the count reaches zero, the full-screen loading indicator will disappear.
	 */
	endLoading() {
		this.updateLoadingCount(-1);
	}

	updateLoadingCount(addCount) {
		// using setTimeout here instead of immediately updating this.loading avoids an ExpressionChangedAfterItHasBeenCheckedError,
		// because child components update this loading state after this has already rendered. that could cause problems in production.
		// setTimeout is a hacky way to defer this update to the next round of change detection
		setTimeout(() => {
			this.loading += addCount;
			if (this.loading < 0) {
				this.loading = 0;
			}
		}, 0);
	}

	activateLoadingTab(tab, tabsData) {
		tabsData.forEach(function (d, i) {
			if (d.prop === tab.prop) {
				d.loading = true;
			}
		});
	}

	deactivateLoadingTab(tab, tabsData) {
		tabsData.forEach(function (d, i) {
			if (d.prop === tab.prop) {
				d.loading = false;
			}
		});
	}

	clearLoading() {
		this.loading = 0;
	}

	calcSize(service) {
		service.windowWidth = window.outerWidth;
		service.windowHeight = window.outerHeight;
	}

	resizeWindow() {
		const delay = setTimeout(function () {
			window.dispatchEvent(new Event('resize'));
		}, 100);
	}

	goBack(delayTime) {
		const delay = setTimeout(function () {
			window.history.back();
		}, delayTime);
	}

	addLoaderId(loaderId) {
		this.loaderIds.push(loaderId);
	}

	removeLoaderId(loaderId) {
		let matchedId = -1;
		this.loaderIds.forEach(function (d, i) {
			if (d === loaderId) {
				matchedId = i;
			}
		});
		if (matchedId > -1) {
			this.loaderIds.splice(matchedId, 1);
		}
	}

	showloaderId(loaderId) {
		let showloaderId = false;
		this.loaderIds.forEach(function (d, i) {
			if (d === loaderId) {
				showloaderId = true;
			}
		});
		return showloaderId;
	}

}
